const state = {
  //@ts-ignore
  jobs: JSON.parse(localStorage.getItem("jobs")) || [],
  //@ts-ignore
  abnormalities: JSON.parse(localStorage.getItem("abnormalities")) || [],
  //@ts-ignore
  service_types: JSON.parse(localStorage.getItem("service_types")) || [],
  //@ts-ignore
  providers: JSON.parse(localStorage.getItem("providers")) || [],
  reason_for_not_signings:
    //@ts-ignore
    JSON.parse(localStorage.getItem("reason_for_not_signings")) || [],
}

export default {
  ...state,
  routeItem: {},
  routeItems: [],
}
